/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import Button from 'carbon-react/lib/components/button';

import { UIWizardFlowSaving } from '@futrli/ui-components';

import { useConsolidationContext } from '../../consolidation-context/consolidation-context';
import { hasEnoughOrganisations } from '../../consolidation-context/utils';
import styles from './top-buttons.scss';
import { TABS } from '../../constants';

interface TopButtonsProps {
  onExit?: () => void;
}

export const TopButtons = ({ onExit }: TopButtonsProps) => {
  const {
    currencies,
    flags: { isSaving },
    handleSubmit,
    handleSubmitAndExit,
    settings: { presentationCurrency, settingsForm, selectedOrganisations }
  } = useConsolidationContext();

  const { tabId } = useParams();

  const invalidSettings = !settingsForm.formState.isValid;
  const notEnoughEntitiesSelected = !hasEnoughOrganisations(selectedOrganisations || [], presentationCurrency);

  const presentationCurrencyData = currencies?.find(c => c.code === presentationCurrency);

  return (
    <div className={styles.buttonBar}>
      <div className={styles.leftContainer}>
        {tabId === TABS.DAILY_FX_RATES && (
          <div className={styles.presentationCurrency}>
            {presentationCurrency && (
              <>
                <FormattedMessage id="consolidation.current_display_currency" defaultMessage="Display currency:" />{' '}
                <span className={styles.currencyName}>{presentationCurrencyData?.displayName}</span>
              </>
            )}
            <p className={styles.disclaimer}>
              <FormattedMessage
                id="consolidation.exchange_rate_footer"
                defaultMessage="Exchange rate data provided by {provider}. Data is updated every {hours} hours at {time}."
                values={{
                  provider: 'Open Exchange Rates (UK) Limited',
                  hours: '24',
                  time: '01:00:00 GMT'
                }}
              />
            </p>
          </div>
        )}
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.buttonContainer}>
          {isSaving && <UIWizardFlowSaving style={{ marginRight: 20 }} />}
          <Button onClick={onExit} buttonType="secondary" mr="10px" size="small" disabled={isSaving}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
          <Button
            onClick={handleSubmit}
            size="small"
            buttonType="primary"
            disabled={invalidSettings || notEnoughEntitiesSelected || isSaving}
          >
            <FormattedMessage id="common.save" defaultMessage="Save" />
          </Button>
          <Button
            ml="10px"
            onClick={handleSubmitAndExit}
            size="small"
            buttonType="primary"
            disabled={invalidSettings || notEnoughEntitiesSelected || isSaving}
          >
            <FormattedMessage id="common.save_and_close" defaultMessage="Save & Close" />
          </Button>
        </div>
      </div>
    </div>
  );
};
